import StdInput from "./StdInput";
import { strLang } from "../functions/strLang";
import MiniButton from "./MiniButton";
import ClearIcon from "@mui/icons-material/Clear";
import ReplayIcon from "@mui/icons-material/Replay";

export default function Header({
  MainIcon,
  color,
  input = false,
  type = "text",
  searchStyle = {},
  value,
  onClick,
  onChange,
  children,
  subMenu,
  clear,
  refresh,
}) {
  return (
    <div className="header">
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: 5,
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 5,
            paddingLeft: 10,
          }}
        >
          <MainIcon style={{ fontSize: 40, color }} />
          {input && (
            <StdInput
              placeholder={strLang("search")}
              type={type}
              value={value}
              change={onChange}
              onClick={onClick}
              style={{ width: 120, ...searchStyle }}
            />
          )}
          {clear && <MiniButton Icon={ClearIcon} onClick={clear} />}
          {refresh && <MiniButton Icon={ReplayIcon} onClick={refresh} />}
        </div>
        {!!children && (
          <div
            style={{
              paddingRight: 10,
            }}
          >
            {children}
          </div>
        )}
      </div>
      {subMenu && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#EEEEEE",
            gap: 5,
            paddingTop: 5,
          }}
        >
          {subMenu}
        </div>
      )}
    </div>
  );
}
